import type { RxJsonSchema } from 'rxdb';
import type { ElevationRange } from './elevationRange.types';

export const elevationRangeSchema: RxJsonSchema<ElevationRange> = {
  type: 'object',
  version: 1,
  description: 'describes elevation range',
  primaryKey: 'areaId',
  properties: {
    areaId: { type: 'string', maxLength: 36 },
    name: { type: ['string', 'null'] },
    areaPcsId: { type: ['string', 'null'] },
    fkParentArea: { type: ['number', 'null'] },
    parentAreaName: { type: ['string', 'null'] },
    parentAreaPcsId: { type: ['string', 'null'] },
    lowerElevation: { type: ['string', 'null'] },
    upperElevation: { type: ['string', 'null'] },
    trafficSafety: { type: ['number', 'null'] },
    isActive: { type: ['boolean', 'null'] },
    site: { type: ['number', 'null'] },
    discipline: { type: ['number', 'null'] },
    dateCreated: { type: ['string', 'null'] },
    dateModified: { type: ['string', 'null'] },
  },
};
